import { render, staticRenderFns } from "./taili_2024_doc.vue?vue&type=template&id=47aec806&scoped=true"
import script from "./taili_2024_doc.vue?vue&type=script&lang=js"
export * from "./taili_2024_doc.vue?vue&type=script&lang=js"
import style0 from "./taili_2024_doc.vue?vue&type=style&index=0&id=47aec806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aec806",
  null
  
)

export default component.exports